import type { Data, UniqueIdentifier } from "@dnd-kit/abstract";
import { CollisionPriority } from "@dnd-kit/abstract";
import { pointerIntersection } from "@dnd-kit/collision";
import { useDroppable } from "@dnd-kit/react";
import ListDropIndicator, {
  type ListDropIndicatorDirection,
} from "../ListDropIndicator/ListDropIndicator";

export type SortableDropSlotProps = {
  id: UniqueIdentifier;
  activeDirection?: ListDropIndicatorDirection;
  targetDirection?: ListDropIndicatorDirection;
  enabled?: boolean;
  accept?: string[];
  data?: Data;
  className?: string;
};

export default function SortableDropSlot({
  id,
  activeDirection,
  targetDirection,
  enabled = false,
  accept,
  data,
  className = "",
}: SortableDropSlotProps) {
  const { ref, isDropTarget } = useDroppable({
    id,
    type: "sortable-drop-slot",
    accept,
    data,
    disabled: !enabled,
    collisionPriority: CollisionPriority.Highest,
    collisionDetector: pointerIntersection,
  });
  const direction = activeDirection ?? (isDropTarget ? targetDirection : null);

  return (
    <div
      ref={ref}
      className={`flex h-3 w-full items-center ${className}`}
      data-drop-slot={String(id)}
      data-active-direction={direction ?? undefined}
    >
      {direction && <ListDropIndicator direction={direction} />}
    </div>
  );
}
